<template>
  <div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
      <div class="card">
        <FlashMessage :position="'right top'"></FlashMessage>

        <div class="card-header">
          <h4 class="title">Edit Product</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="update" enctype="multipart/form-data">
            <div class="row">
              <div class="col-md-6">
                <label>Category<em style="color: red">*</em></label>
                <select
                  class="form-control"
                  v-model.trim="$v.productdata.categoryid.$model"
                >
                  <option disabled value>Select category</option>
                  <option
                    v-for="(list, index) in category"
                    :value="list.categoryid"
                    :key="index"
                  >
                    {{ list.categoryname }}
                  </option>
                </select>
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.categoryid.required"
                >
                  Please select category
                </div>
              </div>

              <div class="col-md-6">
                <label>Sub Category<em style="color: red">*</em></label>
                <select
                  class="form-control"
                  v-model.trim="$v.productdata.subcategoryid.$model"
                >
                  <option disabled value>Select subcategory</option>
                  <option
                    v-for="(list, index) in subcategory"
                    :value="list.subcategoryid"
                    :key="index"
                  >
                    {{ list.subcategoryname }}
                  </option>
                </select>
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.subcategoryid.required"
                >
                  Please select subcategory
                </div>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-12">
                <label>Product<em style="color: red">*</em></label>
                <input
                  class="form-control"
                  v-model.trim="$v.productdata.productname.$model"
                  type="text"
                  label="Product"
                  placeholder="Enter product"
                />
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.productname.required"
                >
                  Please enter product
                </div>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-12">
                <label>Short Description<em style="color: red">*</em></label>
                <textarea
                  class="form-control"
                  v-model.trim="$v.productdata.shortproductdescription.$model"
                  placeholder="Enter product description"
                ></textarea>
                <div
                  class="error"
                  v-if="
                    submitted &&
                    !$v.productdata.shortproductdescription.required
                  "
                >
                  Please enter short description
                </div>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-12">
                <label>Description<em style="color: red">*</em></label>
                <ckeditor
                  :editor="editor"
                  v-model.trim="$v.productdata.productdescription.$model"
                >
                </ckeditor>
                <!-- <textarea class="form-control" v-model.trim="$v.productdata.productdescription.$model" placeholder="Enter product description"></textarea> -->
                <div
                  class="error"
                  v-if="
                    submitted && !$v.productdata.productdescription.required
                  "
                >
                  Please enter product description
                </div>
              </div>
            </div>
            <br />

            <div class="row">
              <div class="col-md-4">
                <label>SKU<em style="color: red">*</em></label>
                <input
                  class="form-control"
                  v-model.trim="$v.productdata.sku.$model"
                  type="text"
                  label="SKU"
                  placeholder="Enter SKU"
                />
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.sku.required"
                >
                  Please enter SKU
                </div>
              </div>

              <div class="col-md-4">
                <label>Price<em style="color: red">*</em></label>
                <input
                  class="form-control"
                  v-model.trim="$v.productdata.price.$model"
                  type="text"
                  label="Price"
                  placeholder="Enter price"
                  @keypress="onlyNumber"
                />
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.price.required"
                >
                  Please enter price
                </div>
              </div>

              <div class="col-md-4">
                <label>Discount Price</label>
                <input
                  class="form-control"
                  v-model.trim="productdata.discountprice"
                  type="text"
                  label="Discount Price"
                  placeholder="Enter discount price"
                  @keypress="onlyNumber"
                />
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col-md-4">
                <label>Quantity<em style="color: red">*</em></label>
                <input
                  class="form-control"
                  v-model.trim="$v.productdata.quantity.$model"
                  type="text"
                  label="quantity"
                  placeholder="Enter quantity"
                  @keypress="onlyNumber"
                />
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.quantity.required"
                >
                  Please enter quantity
                </div>
              </div>

              <div class="col-md-4">
                <label>Image<em style="color: red">*</em></label>
                <input
                  class="form-control"
                  type="file"
                  label="Image"
                  name="productimage"
                  ref="productimage"
                  id="productimage"
                  @change="onFileSelected"
                  accept="image/x-png,image/gif,image/jpeg"
                  multiple
                />
                <span
                  v-for="data in productdata.productimage"
                  v-bind:key="data"
                >
                  <img
                    :src="api + '/storage/image/' + data"
                    height="50px"
                    width="50px"
                  />
                </span>
                <!-- <div class="error" v-if="submitted && !$v.productdata.productimage.required">Please select image</div> -->
              </div>

              <div class="col-md-4">
                <label>Status<em style="color: red">*</em></label>
                <select
                  class="form-control"
                  v-model.trim="$v.productdata.productstatus.$model"
                >
                  <option disabled>Select status</option>
                  <option value="1">Active</option>
                  <option value="0">InActive</option>
                </select>
                <div
                  class="error"
                  v-if="submitted && !$v.productdata.productstatus.required"
                >
                  Please select status
                </div>
              </div>
            </div>
            <br />
            <div>
              <input
                type="checkbox"
                name="onsale"
                :true-value="1"
                :false-value="0"
                v-model="productdata.onsale"
              />
              ON SALE&nbsp;
              <input
                type="checkbox"
                name="featured"
                :true-value="1"
                :false-value="0"
                v-model="productdata.featured"
              />
              FEATURED&nbsp;
              <input
                type="checkbox"
                name="newarrival"
                :true-value="1"
                :false-value="0"
                v-model="productdata.newarrival"
              />
              NEW ARRIVAL&nbsp;
              <input
                type="checkbox"
                name="bestsellers"
                :true-value="1"
                :false-value="0"
                v-model="productdata.bestsellers"
              />
              BEST SELLERS&nbsp;
            </div>

            <div class="text">
              <button type="submit" class="btn btn-secondary dashboard">
                update</button
              >&nbsp;
              <router-link to="/admin/dashboard/product"
                ><button type="button" class="btn btn-secondary dashboard">
                  Cancel
                </button></router-link
              >
            </div>
          </form>
        </div>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
  required,
  minLength,
  maxLength,
  between,
  number,
  file_size_validation,
} from "vuelidate/lib/validators";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { exit } from "process";
export default {
  name: "editProduct",
  components: {
    TopNavbar,
    ContentFooter,
    ValidationError,
  },

  data() {
    return {
      editor: ClassicEditor,
      api: process.env.VUE_APP_API_BASE_URL,
      submitted: false,
      category: [],
      subcategory: [],
      productdata: {
        categoryid: "",
        subcategoryid: "",
        productname: "",
        sku: "",
        price: "",
        quantity: "",
        productdescription: "",
        shortproductdescription: "",
        productimage: [],
        productstatus: "1",
        onsale: "",
        featured: "",
        newarrival: "",
        bestsellers: "",
        discountprice: "",
      },
    };
  },

  validations: {
    productdata: {
      categoryid: {
        required,
      },
      subcategoryid: {
        required,
      },
      productname: {
        required,
      },
      sku: {
        required,
      },
      price: {
        required,
      },
      quantity: {
        required,
      },
      productdescription: {
        required,
      },
      shortproductdescription: {
        required,
      },
      productstatus: {
        required,
      },
    },
  },

  methods: {
    onlyNumber($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    onFileSelected(event) {
      this.productdata.productimage = event.target.files[0];
    },

    update() {
      let formData = new FormData();
      formData.append("categoryid", this.productdata.categoryid);
      formData.append("subcategoryid", this.productdata.subcategoryid);
      formData.append("productname", this.productdata.productname);
      formData.append("sku", this.productdata.sku);
      formData.append("price", this.productdata.price);
      formData.append("quantity", this.productdata.quantity);
      formData.append(
        "productdescription",
        this.productdata.productdescription
      );
      formData.append("productstatus", this.productdata.productstatus);
      formData.append("onsale", this.productdata.onsale);
      formData.append("featured", this.productdata.featured);
      formData.append("newarrival", this.productdata.newarrival);
      formData.append("bestsellers", this.productdata.bestsellers);
      formData.append("discountprice", this.productdata.discountprice);
      formData.append(
        "shortproductdescription",
        this.productdata.shortproductdescription
      );

      for (var i = 0; i < this.$refs.productimage.files.length; i++) {
        let file = this.$refs.productimage.files[i];
        formData.append("productimage[" + i + "]", file);
      }

      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.axios
          .post(
            `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/product/update/` +
              this.$route.params.id,
            formData
          )
          .then(({ data }) => {
            this.$router.push("/admin/dashboard/product");
            this.flashMessage.success({
              message: "Product Updated Successfully",
            });
          })
          .catch((error) => {
            // console.log(error.response)
            if (error.response.data.errors.sku) {
              this.flashMessage.error({
                message: error.response.data.errors.sku[0],
              });
            }
          });
      }
    },
  },
  watch: {
    "productdata.categoryid": function (value) {
      this.axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivesubcategory/` +
            this.productdata.categoryid
        )
        .then((subcategory) => {
          this.subcategory = subcategory.data;
        });
    },
  },

  async mounted() {
    await this.axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactivecategory`
      )
      .then((category) => {
        this.category = category.data;
      });

    const productdata = await this.axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/product/edit/` +
        this.$route.params.id
    );
    this.productdata = productdata.data.data;
    this.productdata.productimage = productdata.data.data.productimage
      .toString()
      .split("|");
    // console.log(productdata.data.data.productimage.toString().split('|'))
  },
};
</script>

<style lang="scss">
</style>
